import axios from 'axios';
import qs from 'qs';

// 全局变量，用于标记是否已经弹出过超时提示
let hasShownTimeoutAlert = false;

import { vm } from '../main.js';

//根据环境变量区分接口的默认地址
console.log(process.env.NODE_ENV,'process.env.NODE_EVN');
console.log('VUE_APP_BASE_API', process.env.VUE_APP_BASE_API);

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
// 设置超时时间和跨域是否允许携带凭证
// axios.defaults.timeout = 10000; //10s
axios.defaults.timeout = -1; //10s
axios.defaults.withCredentials = false; //是否允许携带凭证

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';   //get请求处理
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';   //post请求处理
// axios.defaults.transformRequest = data => qs.stringify(data);   //post请求处理

// axios.defaults.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8';   //post请求处理

//设置请求拦截器
axios.interceptors.request.use(config => {
    config.url === '/uploadUtil' && (config.headers['content-type'] = 'multipart/form-data;charset=UTF-8');
	// config.url == '/uploadUtil' && (config.headers['Content-Type'] = false);

	let token = JSON.parse(localStorage.getItem('lifeData'))?.vuex_token
	token && (config.headers.Authorization = 'Bearer '+token)
    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截器
 * */
// axios.defaults.validateStatus = status =>{
//     // 自定义响应成功的HTTP状态码
//     return /^(2|3)\d{2}$/.test(status))
// }
axios.interceptors.response.use(response => {

	if (response.data.code === 401 && !hasShownTimeoutAlert) {
        hasShownTimeoutAlert = true;
        if(hasShownTimeoutAlert){
            vm.$alert('登录已过期,请重新登录', '', {
                confirmButtonText: '确定',
                showClose: false,
                type: 'error',
                callback: action => {
                    hasShownTimeoutAlert = false;
                    vm.$router.replace('/login')
                }
            });
            return
        }
	}


	if(response.data != null){
		return response.data
	}


}, error => {
    let { response } = error;
    if (response) {
        //服务器最起码返回结果了
        switch (response.code) {
            case 401:  // => 权限   //一般是当前用户需要验证(一般是未登录)

                break;
            case 403: // 服务器已经理解请求，但是拒绝执行它 (一般是token过期)
                break;
            case 404: //请求的资源未在服务器找到
                break;
        }
        return Promise.reject(error)
    } else {
        //服务器连结果都没有返回
        if (!window.navigator.onLine) {
            //断网处理:可以跳转到断网页面
            return;
        }
        return Promise.reject(error)
    }
})

export default axios
